import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [MatIcon, TranslateModule],
})
export class SnackbarComponent {
  public data: SnackbarData = inject(MAT_SNACK_BAR_DATA);
}

export interface SnackbarData {
  messageKey: string;
  iconKey: string;
}
